/**Filters movies based on their experience
 * @param {Object} filterParams the parameters to use to filter
 * @param {string} filterParams.experience The experience, can be "2D","3D"
 * @param {string} filterParams.searchQuery The search query string
 * @param {Object[]} _movieList The list of movies to filter
 * @param {Function} setFilteredMovieList A set state function to update the state of movies
 */
export const filterMovies = (
  { experience = "2D/3D", searchQuery = "" },
  _movieList,
  setFilteredMovieList
) => {
  setFilteredMovieList(
    _movieList
      .filter((movie) =>
        searchQuery ? search(searchQuery, movie.MovieName) : true
      )

      .filter((movie) =>
        experience !== "2D/3D" ? movie.MovieName.includes(experience) : true
      )
  );
};

/**A simple search function
 * @param {string} searchQuery A string to use to perform the search
 * @param {string} stringToSearch The string we are searching through
 * @return {boolean} Returns true if any of the words in {@link searchQuery} appear in {@link stringToSearch}
 */
const search = (searchQuery, stringToSearch) => {
  let listOfWords = searchQuery.split(" ");
  return listOfWords.every((word) =>
    word ? new RegExp(word, "ig").test(stringToSearch) : true
  );
};
